import {
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    CardBody,
    Flex,
    Heading,
    IconButton,
    Skeleton,
    Stack,
    Text,
    useDisclosure, useToast,
    SimpleGrid,
    Icon,
    HStack,
    VStack,
    Divider,
    Tag,
    Container,
    Center
} from "@chakra-ui/react";
import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Roles } from "../../interfaes/user";
import { RelationShip, Student } from "../../interfaes/student";
import { MdAdd, MdFileDownload } from "react-icons/md";
import ManageIEP from "./ManageIEP";
import { onGetStudent } from "../../http/student";
import { onDeleteIEP, onGetIEP } from "../../http/iepAPis";
import { onGetSchools } from "../../http/school";
import { IEP } from "../../interfaes/iep";
import { School } from "../../interfaes/school";
import { GrEdit } from "react-icons/gr";
import { canAddStudent, isAdmin } from "../../utils/common";
import StudentProgress from "./StudentProgress";
import { MdDelete } from "react-icons/md";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import { FiUser, FiMapPin, FiInfo, FiCalendar, FiPhone, FiBookOpen, FiGlobe, FiShield, FiEdit2 } from "react-icons/fi";
import { BrandButton } from "../../components/TablePageShell";


export default function StudentProfile() {
    const { t } = useTranslation('iep');
    const { state } = useLocation();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenDelete, onOpen: onOpenDelete, onClose: onCloseDelete } = useDisclosure();
    const [iep, setIep] = useState<IEP[]>([]);
    const [student, setStudent] = useState<Student | undefined>(undefined);
    const [schools, setSchools] = useState<School[]>([]);
    const [selectedIEP, setSelectedIEP] = useState<IEP | undefined>(undefined)
    const navigate = useNavigate();
    const { id } = useParams();

    const handleGetIEP = useCallback(async () => {
        try {
            const studentId = state ? state.studentId : id;
            const response = await onGetIEP(studentId);
            setIep(response.data);
        } catch (e) {
            console.log(e)
        }
    }, [state, id]);

    const handleGetSchools = useCallback(async () => {
        try {
            const response = await onGetSchools();
            setSchools(response.data.items);
        } catch (e) {
            console.log(e);
        }
    }, []);

    const handleGetStudent = useCallback(async () => {
        try {
            const studentId = state ? state.studentId : id;
            if (studentId) {
                const response = await onGetStudent(studentId);
                setStudent(response.data);
            }
        } catch (e) {
            console.log(e);
        }
    }, [state, id]);

    useEffect(() => {
        handleGetIEP();
        handleGetSchools();
        handleGetStudent();
    }, [handleGetIEP, handleGetSchools, handleGetStudent]);

    const handleClose = () => {
        setSelectedIEP(undefined);
        onClose();
        onCloseDelete();
        setDeleteIndex('');
        setLoading(false)
        handleGetIEP();
    }

    const [loading, setLoading] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState("");
    const toast = useToast();

    const handleDeleteIEP = async () => {
        try {
            setLoading(true)
            const studentId = state ? state.studentId : id;
            await onDeleteIEP(studentId, deleteIndex);
            const arrayOfObjects = iep.filter((obj: IEP) => obj.iepId !== deleteIndex);
            setIep(arrayOfObjects);
            toast({
                title: 'Deleted',
                description: "IEP Deleted Successfully!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
        } catch (e) {
            toast({
                title: 'Error',
                // @ts-ignore
                description: e?.response?.data?.message,
                status: 'error',
                duration: 3000,
                isClosable: true,
            })
        } finally {
            handleClose();
        }
    }

    const InfoItem = ({ icon, label, value }: { icon: any, label: string, value?: string | number }) => (
        <HStack spacing={3} alignItems="flex-start">
            <Center w="36px" h="36px" borderRadius="10px" bg="blue.50" color="blue.500">
                <Icon as={icon} />
            </Center>
            <VStack align="start" spacing={0}>
                <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase">
                    {label}
                </Text>
                <Text fontSize="sm" fontWeight="600" color="gray.800">
                    {value || '-'}
                </Text>
            </VStack>
        </HStack>
    );

    if (student) {
        const parent = student.relationships?.filter((r: RelationShip) => r.relation === Roles.PARENT)[0];
        const teacher = student.relationships?.filter((r: RelationShip) => r.relation === Roles.TEACHER)[0];
        const therapist = student.relationships?.filter((r: RelationShip) => r.relation === Roles.THERAPIST)[0];

        return (
            <Box pb={10}>
                {/* Header Actions */}
                <Flex justifyContent="space-between" alignItems="center" mb={6}>
                    <Heading size="lg" fontWeight="900" color="gray.800">
                        {t('title')}
                    </Heading>
                    <HStack spacing={3}>
                        <BrandButton
                            leftIcon={<FiEdit2 />}
                            variant="outline"
                            colorScheme="blue"
                            onClick={() => navigate(`/students/${student.studentId}`, { state: student })}
                        >
                            Edit Profile
                        </BrandButton>
                    </HStack>
                </Flex>

                {/* Main Profile Card */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)" mb={8} overflow="hidden">
                    <Box h="15px" bgGradient="linear(to-r, blue.400, blue.600)" />
                    <CardBody>
                        <Flex direction={{ base: 'column', lg: 'row' }} px={4} gap={8}>
                            {/* Avatar Section */}
                            <VStack align={{ base: 'center', lg: 'flex-start' }} w={{ base: '100%', lg: '250px' }}>
                                <Avatar
                                    size="2xl"
                                    name={student.fullName}
                                    src={student.studentImage}
                                    border="4px solid white"
                                    boxShadow="md"
                                />
                                <VStack align={{ base: 'center', lg: 'flex-start' }} spacing={1} mt={2}>
                                    <Heading size="md" fontWeight="bold">{student.fullName}</Heading>
                                    <Tag colorScheme="blue" borderRadius="full" px={3}>
                                        {student.gender === 'M' ? 'Male' : student.gender === 'F' ? 'Female' : 'Others'}
                                    </Tag>
                                </VStack>
                            </VStack>

                            {/* Details Grid */}
                            <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={8} flex={1} py={4}>
                                {/* Basic Info */}
                                <VStack align="start" spacing={5}>
                                    <Heading
                                        size="xs"
                                        color="gray.800"
                                        fontWeight="800"
                                        textTransform="uppercase"
                                        letterSpacing="wider"
                                        borderBottom="2px solid"
                                        borderColor="blue.500"
                                        pb={1}
                                        width="fit-content"
                                    >
                                        Basic Info
                                    </Heading>
                                    <InfoItem icon={FiCalendar} label="Date of Birth" value={student.dob ? new Date(student.dob).toLocaleDateString() : 'N/A'} />
                                    <InfoItem icon={FiGlobe} label="Language" value={student.language} />
                                    <InfoItem icon={FiShield} label="IEMIS Number" value={student.IEMISNumber} />
                                    <InfoItem icon={FiShield} label="National ID" value={student.nationalId} />
                                </VStack>

                                {/* Address & Contact */}
                                <VStack align="start" spacing={5}>
                                    <Heading
                                        size="xs"
                                        color="gray.800"
                                        fontWeight="800"
                                        textTransform="uppercase"
                                        letterSpacing="wider"
                                        borderBottom="2px solid"
                                        borderColor="blue.500"
                                        pb={1}
                                        width="fit-content"
                                    >
                                        Location & Contact
                                    </Heading>
                                    <InfoItem icon={FiMapPin} label="Permanent Address" value={`${student.localAddress}, ${student.localLevel}, ${student.district}`} />
                                    {student.tempLocalAddress && student.tempLocalAddress !== student.localAddress && (
                                        <InfoItem icon={FiMapPin} label="Temporary Address" value={`${student.tempLocalAddress}, ${student.tempLocalLevel}, ${student.tempDistrict}`} />
                                    )}
                                    <InfoItem icon={FiPhone} label="Contact" value={student.contact} />
                                </VStack>

                                {/* Disability */}
                                <VStack align="start" spacing={5}>
                                    <Heading
                                        size="xs"
                                        color="gray.800"
                                        fontWeight="800"
                                        textTransform="uppercase"
                                        letterSpacing="wider"
                                        borderBottom="2px solid"
                                        borderColor="blue.500"
                                        pb={1}
                                        width="fit-content"
                                    >
                                        Special Needs
                                    </Heading>
                                    <InfoItem icon={FiInfo} label="Disability Type" value={student.disabilityType} />
                                    <InfoItem icon={FiInfo} label="Disability ID" value={student.disabilityId} />
                                    <InfoItem icon={FiBookOpen} label="Service Area" value={student.serviceArea} />
                                </VStack>

                                {/* Assignments & Relationships */}
                                <VStack align="start" spacing={5}>
                                    <Heading
                                        size="xs"
                                        color="gray.800"
                                        fontWeight="800"
                                        textTransform="uppercase"
                                        letterSpacing="wider"
                                        borderBottom="2px solid"
                                        borderColor="blue.500"
                                        pb={1}
                                        width="fit-content"
                                    >
                                        Assigned & Relationship
                                    </Heading>
                                    <InfoItem icon={FiBookOpen} label="School" value={student.school?.name || schools.find(s => s.id === student.schoolId)?.name || 'N/A'} />
                                    <InfoItem icon={FiUser} label="Parent" value={parent ? `${parent.relatedUser.displayName} (${parent.relatedUser.phone})` : 'N/A'} />
                                    <InfoItem icon={FiUser} label="Teacher" value={teacher?.relatedUser?.displayName || 'N/A'} />
                                    <InfoItem icon={FiUser} label="Therapist" value={therapist?.relatedUser?.displayName || 'N/A'} />
                                </VStack>
                            </SimpleGrid>
                        </Flex>
                    </CardBody>
                </Card>

                {/* Bottom Section */}
                <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={8}>
                    {/* IEP List Section */}
                    <Box>
                        <Flex justifyContent="space-between" alignItems="center" mb={4}>
                            <HStack spacing={2}>
                                <Icon as={FiBookOpen} color="blue.500" w={5} h={5} />
                                <Heading size="md" fontWeight="bold">{t('iepProfile')}</Heading>
                            </HStack>
                            {canAddStudent() && (
                                <BrandButton
                                    leftIcon={<MdAdd />}
                                    onClick={onOpen}
                                >
                                    {t('addIep')}
                                </BrandButton>
                            )}
                        </Flex>

                        <VStack spacing={4} align="stretch">
                            {iep.length === 0 && (
                                <Box p={10} bg="gray.50" borderRadius="20px" textAlign="center" border="2px dashed" borderColor="gray.200">
                                    <Text color="gray.500">No IEP reports found for this student.</Text>
                                </Box>
                            )}
                            {iep.map((i) => (
                                <Card
                                    key={i.iepId}
                                    bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)"
                                    transition="all 0.2s"
                                    _hover={{ shadow: 'md', transform: 'translateY(-2px)', borderColor: 'blue.200' }}
                                    onClick={() => navigate('/iep/' + i.iepId, {
                                        state: { student, iep: i }
                                    })}
                                    cursor="pointer"
                                    overflow="hidden"
                                >
                                    <CardBody p={5}>
                                        <Flex direction="column" gap={3}>
                                            <Flex justifyContent="space-between" alignItems="center">
                                                <HStack spacing={3}>
                                                    <Box boxSize="40px" borderRadius="10px" bg={i.completed ? "green.50" : "blue.50"} display="flex" alignItems="center" justifyContent="center">
                                                        <Icon as={FiBookOpen} color={i.completed ? "green.500" : "blue.500"} />
                                                    </Box>
                                                    <VStack align="start" spacing={0}>
                                                        <Heading size="sm">{i.year}</Heading>
                                                        <Text fontSize="xs" color="gray.500">{`${t('level')} ${i.level} | ${t('section')} ${i.section}`}</Text>
                                                    </VStack>
                                                </HStack>
                                                <Badge colorScheme={i.completed ? 'green' : 'blue'} borderRadius="full" px={3} py={1}>
                                                    {i.completed ? t('completed') : t('inProgress')}
                                                </Badge>
                                            </Flex>

                                            <Divider />

                                            <Flex justifyContent="flex-end" gap={2} onClick={(e) => e.stopPropagation()}>
                                                <IconButton
                                                    size="sm"
                                                    variant="ghost"
                                                    colorScheme="blue"
                                                    aria-label="Download"
                                                    icon={<MdFileDownload size="20px" />}
                                                    onClick={() => navigate('/student-report/' + student?.studentId + '/' + i?.iepId)}
                                                />
                                                <IconButton
                                                    size="sm"
                                                    variant="ghost"
                                                    colorScheme="red"
                                                    aria-label="Edit"
                                                    icon={<GrEdit />}
                                                    onClick={() => {
                                                        setSelectedIEP(i);
                                                        onOpen();
                                                    }}
                                                />
                                                {isAdmin() && (
                                                    <IconButton
                                                        size="sm"
                                                        variant="ghost"
                                                        colorScheme="red"
                                                        aria-label="Delete"
                                                        icon={<MdDelete size="20px" />}
                                                        onClick={() => {
                                                            setDeleteIndex(i.iepId || '');
                                                            onOpenDelete();
                                                        }}
                                                    />
                                                )}
                                            </Flex>
                                        </Flex>
                                    </CardBody>
                                </Card>
                            ))}
                        </VStack>
                    </Box>

                    {/* Progress Section */}
                    <Box>
                        <Flex alignItems="center" mb={4} gap={2}>
                            <Icon as={FiInfo} color="blue.500" w={5} h={5} />
                            <Heading size="md" fontWeight="bold">Student Progress</Heading>
                        </Flex>
                        <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)" overflow="hidden">
                            <CardBody p={4}>
                                <StudentProgress studentID={state ? state.studentId : id} />
                            </CardBody>
                        </Card>
                    </Box>
                </SimpleGrid>

                <ManageIEP isOpen={isOpen} onOpen={onOpen} onClose={handleClose} studentId={state ? state.studentId : id} selectedIEP={selectedIEP} />
                <CoustomAlertDialog
                    onClose={handleClose}
                    onOpen={onOpenDelete}
                    isOpen={isOpenDelete}
                    onMainAction={handleDeleteIEP}
                    loading={loading}
                />
            </Box>
        )
    } else {
        return (
            <Container maxW="container.xl" py={10}>
                <Stack spacing={6}>
                    <Skeleton height="100px" borderRadius="20px" />
                    <Skeleton height="300px" borderRadius="20px" />
                    <SimpleGrid columns={2} spacing={8}>
                        <Skeleton height="400px" borderRadius="20px" />
                        <Skeleton height="400px" borderRadius="20px" />
                    </SimpleGrid>
                </Stack>
            </Container>
        )
    }
}

